import { nothing as t } from "../lit-html.js";
import { AsyncDirective as i } from "../async-directive.js";
import { directive as s } from "../directive.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e = () => new h();
class h {}
const o = new WeakMap(),
  n = s(class extends i {
    render(i) {
      return t;
    }
    update(i, [s]) {
      const e = s !== this.G;
      return e && void 0 !== this.G && this.rt(void 0), (e || this.lt !== this.ct) && (this.G = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), t;
    }
    rt(t) {
      if (this.isConnected || (t = void 0), "function" == typeof this.G) {
        const i = this.ht ?? globalThis;
        let s = o.get(i);
        void 0 === s && (s = new WeakMap(), o.set(i, s)), void 0 !== s.get(this.G) && this.G.call(this.ht, void 0), s.set(this.G, t), void 0 !== t && this.G.call(this.ht, t);
      } else this.G.value = t;
    }
    get lt() {
      return "function" == typeof this.G ? o.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
    }
    disconnected() {
      this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
      this.rt(this.ct);
    }
  });
export { e as createRef, n as ref };
